import React from "react"
import { OutboundLink } from "gatsby-plugin-google-gtag"
import PdfIcon from "../svg/icons/PdfIcon"
import LinkIcon from "../svg/icons/LinkIcon"
import FvIcon from "../svg/tic/fvIcon"
import OgIcon from "../svg/tic/ogIcon"
import UyfIcon from "../svg/tic/uyfIcon"
import WpIcon from "../svg/tic/wpIcon"
import ColumnIcon from "../svg/tic/columnIcon"
import { H4, Trunc } from "../el/appnotetypography"
import googleTag from "../googleTag"
import { twMerge } from "tailwind-merge"
const AppInfoBlock = props => {
  const description = Trunc(props.description, 350)
  const tag = (eventName, params) => {
    googleTag(eventName, params)
  }
  return (
    <div className="mb-8 rounded-sm bg-white shadow-md">
      <div className="h-full rounded-sm pb-6 pt-0 shadow-sm">
        <SidebarProductHeader productLine={props.productLine} />
        <div className="h-full px-4 lg:px-4">
          <div className="h-full py-2">
            <H4>Title</H4>
            <h3
              dangerouslySetInnerHTML={{ __html: props.title }}
              className="pb-3 text-sm font-normal text-slate-600"
            ></h3>
            <H4>Description</H4>
            <p
              dangerouslySetInnerHTML={{ __html: description }}
              className="mb-2 text-xs text-slate-500"
            ></p>
            {props.type !== "video" && props.type !== "webpage" && (
              <a aria-label="Download" download className="" href={props.link}>
                <button
                  aria-label="Download"
                  className="group flex w-full items-center rounded bg-emerald-100 px-1.5 py-1.5 transition hover:bg-emerald-200"
                  onClick={() =>
                    tag("fileDownload", {
                      downloadType: props.type,
                      downloadTitle: props.title,
                    })
                  }
                >
                  <PdfIcon className="mr-1 h-6 w-auto" />
                  <span className="text-xs font-light text-emerald-600 transition group-hover:text-emerald-700">
                    {props.type === "appnote" && "Download Application"}
                    {props.type === "general" && "Download PDF"}
                    {props.type === "brochure" && "Download Brochure"}
                    {props.type === "published" && "Download PDF"}
                  </span>
                </button>
              </a>
            )}
            {props.type === "webpage" && (
              <OutboundLink
                className="group flex items-center rounded bg-blue-100 px-1.5 py-1.5 transition hover:bg-blue-200"
                href={props.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkIcon className="mr-1 h-6 w-auto" />
                <span className="text-xs font-light text-blue-500 transition group-hover:text-blue-700">
                  Visit Page
                </span>
              </OutboundLink>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

const SidebarProductHeader = props => {
  return (
    <div
      className={twMerge([
        "flex h-12 w-full items-center justify-start rounded-t-sm pl-3",
        props.productLine === "FV" &&
          "bg-teal-400 text-teal-50 group-hover:bg-teal-600 group-hover:text-teal-100",
        props.productLine === "OG" &&
          "bg-violet-400 text-violet-50 group-hover:bg-violet-600 group-hover:text-violet-100",
        props.productLine === "UYF" &&
          "bg-indigo-400 text-indigo-50 group-hover:bg-indigo-600 group-hover:text-indigo-100",
        props.productLine === "wellplate" &&
          "bg-pink-400 text-pink-50 group-hover:bg-pink-600 group-hover:text-pink-100",
        props.productLine === "columns" &&
          "bg-blue-400 text-blue-50 group-hover:bg-blue-600 group-hover:text-blue-100",
      ])}
    >
      {props.productLine === "FV" && (
        <FvIcon className="h-8 w-8 fill-current" />
      )}
      {props.productLine === "OG" && (
        <OgIcon className="h-8 w-8 fill-current" />
      )}
      {props.productLine === "UYF" && (
        <UyfIcon className="h-8 w-8 fill-current" />
      )}
      {props.productLine === "wellplate" && (
        <WpIcon className="h-8 w-8 fill-current" />
      )}
      {props.productLine === "columns" && (
        <ColumnIcon className="h-8 w-8 fill-current" />
      )}
    </div>
  )
}

export default AppInfoBlock
